//import get from "lodash.get";
const getNestedProperty = (obj, path, defaultValue = undefined) => {
  const keys = path ? path.split(".") : [];
  let result = obj;

  for (let key of keys) {
    if (result && typeof result === "object" && key in result) {
      result = result[key];
    } else {
      return defaultValue;
    }
  }

  return result;
};
export const exportJson = (
  selectedRows,
  listingOf,
  exportFor,
  columns,
  setGlobalState,
  globalState,
) => {
  const selectedIds = selectedRows.map((row) => row.id);
  const allRecords =
    listingOf?.response && Array.isArray(listingOf.response)
      ? listingOf.response
      : [];

  if (!Array.isArray(allRecords) || allRecords.length === 0) {
    console.warn("No records available for export");
    return false;
  }

  
  // Prepare reports array to store formatted data
  const reports = allRecords
    .filter((list) => selectedIds.includes(list._id || list.id))
    .map((list) => {
      const report = {};
      // Process each column definition
      columns.forEach((col) => {
        let value = getNestedProperty(list, col.path);
        const fatalInfoRaw = getNestedProperty(list, "fatalNotFatalInfo");
        const fatalInfo = fatalInfoRaw ? JSON.parse(fatalInfoRaw) : null;

        const fatal = fatalInfo?.fatal ?? 0;
        const notFatal = fatalInfo?.notFatal ?? 0;

        const auditedScoreInfoRaw = getNestedProperty(list, "auditedScoreInfo");
        const auditedScoreInfo = auditedScoreInfoRaw
          ? JSON.parse(auditedScoreInfoRaw)
          : null;

        const actualScore = auditedScoreInfo?.auditedQuestionCount ?? 0;
        const maxPossible = auditedScoreInfo?.auditedMaxQuestionCount ?? 0;
        const hasWeightage = getNestedProperty(list, "hasWeightage") === "TRUE";
        if (col.path === "hasWeightage") {
          value =
            value === "TRUE"
              ? "Weightage Audit Form"
              : "Non-weightage Audit Form";
        }

        if (col.formatter) {
          // let value = get(list, col.path); // Get value from list using lodash.get
          value = col.formatter(value); // Apply formatter if present
        }
        if (col.key === "Actual Score") {
          value = hasWeightage ? maxPossible - notFatal : actualScore;
        }
        report[col.key] = value || ""; // Assign value to report object
      });

      // Handle additional fields from formContent
      const formContent = list?.formContent && JSON.parse(list?.formContent);
      let allQuestions = formContent?.elements?.questions;

      let ky = 1;
      if (allQuestions) {
        const reorderedQuestions = [
          ...allQuestions.filter(
            (q) =>
              q.display_text ===
                "Reason for markdown (write in details what went wrong & what is the correct process):" ||
              q.display_text ===
                "Reason for markdown (write in details what went wrong & what is the correct process:",
          ),
          ...allQuestions.filter(
            (q) =>
              q.display_text !==
                "Reason for markdown (write in details what went wrong & what is the correct process):" &&
              q.display_text !==
                "Reason for markdown (write in details what went wrong & what is the correct process:",
          ),
        ];
        allQuestions = reorderedQuestions;
        Object.keys(allQuestions).forEach((key) => {
          const display_text = allQuestions[key]?.display_text;
          const qkey = allQuestions[key]?.qkey;
          let finalHeader = display_text;
          const selectedValue =
            exportFor === "FeedbackRequests"
              ? allQuestions[key]?.defaultValue
              : allQuestions[key]?.selectedValue;

          // Normalize only 'markdown-reason' qkey header
          if (qkey === "markdown-reason") {
            finalHeader =
              "Reason for markdown (write in details what went wrong & what is the correct process):";
          }

          // For other qkeys, it remains as-is (display_text)
          if (finalHeader) {
            report[finalHeader] = selectedValue || ""; // Set value in that column for this row
          }

          // Check for sub_questions under the current question
          if (
            allQuestions[key]?.meta?.sub_questions &&
            allQuestions[key]?.meta.sub_questions.length > 0
          ) {
            allQuestions[key]?.meta.sub_questions.forEach((subQuestion) => {
              const sub_display_text = subQuestion?.display_text;
              const sub_selectedValue =
                exportFor === "FeedbackRequests"
                  ? subQuestion?.defaultValue
                  : subQuestion?.selectedValue;

              // Store sub-question in report
              report[`${ky} - ${sub_display_text}`] = sub_selectedValue || "";
            });
            ky = ky + 1;
          }
        });
      }

      return report;
    });

  
  // Update global state with reports and selected row keys
  setGlobalState((prev) => ({
    ...prev,
    [`export${exportFor}Json`]: reports,
    selectedRowKeysChildInfo: selectedIds,
  }));
  return true;
};
